import { ChangeDetectionStrategy, Component, ElementRef, HostListener, Signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable, map, switchMap } from 'rxjs';
import { NoResultComponent } from "../../../../shared/components/no-result/no-result.component";
import { DistributionGroupStore } from '../../store/distribution-group-store';
import { DistributionGroupListHeaderComponent } from "../distribution-group-list-header/distribution-group-list-header.component";
import { DistributionGroupListItemComponent } from "../distribution-group-list-item/distribution-group-list-item.component";
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { DistributionGroup } from 'src/app/models/distribution-group.model';
import { ManipulationsToolbarComponent } from 'src/app/shared/components/manipulations-toolbar/manipulations-toolbar.component';

@Component({
    selector: 'que-distribution-group-list',
    templateUrl: './distribution-group-list.component.html',
    styleUrls: ['./distribution-group-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule,
        TranslateDirective, TranslatePipe, NoResultComponent, DistributionGroupListHeaderComponent, DistributionGroupListItemComponent, ManipulationsToolbarComponent]
})
export class DistributionGroupListComponent {
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  #distributionGroupStore = inject(DistributionGroupStore);
  distributionGroups$ = toSignal(this.#distributionGroupStore.distributionGroup$);
  distributionGroupExtra$ = toSignal(this.#distributionGroupStore.distributionGroupExtra$);
  isResult$ = toSignal(this.#distributionGroupStore.totals$.pipe(map(x => x != undefined && x > 0)));
  isEmpty$ = toSignal(this.#distributionGroupStore.isEmpty$);
  loadingExtra$ = toSignal(this.#distributionGroupStore.loadingExtra$);
  loading$ = toSignal(this.#distributionGroupStore.loading$);
  isFilterListOpen$ = toSignal(this.#manipulationsToolbarStore.isFilterListOpen$);
  constructor(private el: ElementRef) {
  }

  @HostListener('document:mousewheel', ['$event'])
  onWindowScroll(event: any) {
    const scrollContainer = this.el.nativeElement.querySelector('.scroll');
    if (scrollContainer) {
      const scrollBottom = scrollContainer.scrollHeight - scrollContainer.clientHeight;
      if (scrollContainer.scrollTop >= scrollBottom - 1) {
        var is10InExtra = this.distributionGroupExtra$()?.result.length == 10;
        if (this.distributionGroupExtra$()?.result && this.distributionGroupExtra$()!.result.length > 0) {
          this.getDistributionGroupExtra();
        }
        if (this.distributionGroupExtra$() && is10InExtra && !this.loadingExtra$())
          this.loadMore();
      }
    }
  }

  getDistributionGroupExtra() {
    this.#distributionGroupStore.updateDistributionGroupsWithExtra();
  }

  loadMore() {
    this.#distributionGroupStore.loadDistributionGroupForExtra();
  }
  create(){
    
  }
}
